"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castione-della-presolana": {
    "5b18183b": [{
      "hkey": "d1fb92ac",
      "slug": "bratto-dorga",
      "name": "Bratto-Dorga",
      "primary": true,
      "skipSearch": false
    }],
    "bratto": [{
      "hkey": "d1fb92ac",
      "slug": "bratto-dorga",
      "name": "Bratto-Dorga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9729e3d6": [{
      "hkey": "d1fb92ac",
      "slug": "bratto-dorga",
      "name": "Bratto-Dorga",
      "primary": true,
      "skipSearch": false
    }],
    "dorga": [{
      "hkey": "d1fb92ac",
      "slug": "bratto-dorga",
      "name": "Bratto-Dorga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castione-della-presolana"
    }]
  }
};
exports["default"] = _default;